export default __webpack_public_path__ + "static/media/editCompany.1a3c4d02.svg";